export const formatConstraints = (constraints?: any[]): any[] | undefined => (
  constraints ? Object.values(constraints) : undefined
);
